<template lang="html">
  <div class="mb-16">
    <div class="mb-6">
      <div class="title py-3 px-4 title-div">
          <p class="caption mb-0">
              <a href="#/" class="grey--text text--lighten-2">Home / </a>
              <a class="grey--text text--lighten-2">{{$route.params.category}} / </a>
              <a :href="`#/${$route.params.category}/${$route.params.contentType}`" class="grey--text text--lighten-2">{{$route.params.contentType}}</a>
              <!-- <a :href="`#/${$route.params.category}/${$route.params.contentType === 'Management' ? 'Senior Management' : $route.params.contentType}/profiles`" class="grey--text text--lighten-2" v-if="$route.params.contentType === 'Organization Structure'"> / Division Heads</a> -->
          </p>
          {{$route.params.title}}
      </div>
      <v-progress-linear
      v-if="loadingPage"
      indeterminate
      color="primary"
      ></v-progress-linear>
    </div>
    <v-row row wrap class="mt-3 px-4">
      <v-col md="3" class="pl-0  hidden-sm-and-down">
          <div class="">
          <div
          v-for="(value, key) in navItems"
          :key="key"
          >
              <v-list-group
              dense
              class="elevation-0"
              :value="$route.params.category === key ? true : false"
              >
                  <template v-slot:activator>
                      <v-list-item-content>
                          <v-list-item-title class="px-0">{{key}}</v-list-item-title>
                      </v-list-item-content>
                  </template>
                  <v-list-item
                  v-for="n in value"
                  :key="n"
                  @click="() => {}"
                  link
                  :href="n === 'Laws of the Maldives' ? 'https://mvlaw.gov.mv/dv' : n === 'Laws and Regulations' ? 'https://www.mvlaw.gov.mv' :  `#/${key}/${n}`"
                  >
                      <v-list-item-title class="px-0 font-weight-light" :class="$route.params.contentType === n ? 'info--text' : ''">{{n === "Why Join AGO" ? n + '?' : n}}</v-list-item-title>
                      <v-divider></v-divider>
                  </v-list-item>
              </v-list-group>
              <v-divider></v-divider>
          </div>
          </div>
      </v-col>
      <v-col cols="11" sm="11" md="8" >
        <div v-if="!loadingPage">
          <div  v-if="news.length > 0">
            <p class="display-1 primary--text mb-0">
              {{news[0].Title.split('#').length > 1 ? news[0].Title.split('#')[1] : news[0].Title}}
              <a v-if="$route.params.title == 'Deputy Attorney General' || $route.params.title == 'Permanent Secretary' || news[0].Title.includes('Director, Communication')" :href="`https://twitter.com/${$route.params.title == 'Deputy Attorney General' ? 'kshabeen' : $route.params.title == 'Permanent Secretary' ? 'A_Shiyau' : 'HucenHassan'}?ref_src=twsrc%5Etfw`" class="twitter-follow-button" data-size="large" data-show-screen-name="false" data-show-count="false">
                <v-btn :dark="true" style="border-radius: 20px;" x-small color="#1d9cf0" fab :elevation="0">
                  <v-icon>mdi-twitter</v-icon>
                </v-btn>
              </a>
            </p>
            <p class="font-weight-medium mt-3" v-html="news[0].Title.split('#').length > 1 ? news[0].Title.split('#')[0] : ''"></p>

            <!-- <v-card :width="100" flat tile class="float-left" v-if="news[0].Files[0]">
              
            </v-card> -->
            <v-img
            :src="getImage(news[0])"
            :lazy-src="getImage(news[0])"
            :width="200"
            class="transparent float-sm-left mr-4 mt-5 mb-2"
            v-if="getImage(news[0])"
            >
              <template v-slot:placeholder>
                <v-row
                fill-height
                align-center
                justify-center
                ma-0
                >
                  <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <span class="mb-5 ql-editor">
              <span v-html="removeFirstPageQuote(news[0].Body)"></span>
            </span>
            
          </div>
          <div v-else>
              <p class="title">Page Not Found!</p>
          </div>
        </div>

        <!-- <v-alert
          v-else
          :value="true"
          color="info"
          icon="info"
          outline
        >
          This is an info alert.
        </v-alert> -->
      </v-col>
      <v-col cols="1">
          <div class="sticky">
              <v-btn icon class="my-2" @click="printPage()" color="grey lighten-1">
                  <v-icon>mdi-printer</v-icon>
              </v-btn>
              <br>
              <v-btn :href="`http://www.facebook.com/sharer.php?u=${currentUrl}`" target="_blank" icon class="my-2" color="grey lighten-1">
                  <v-icon>mdi-facebook</v-icon>
              </v-btn>
              <br>
              <v-btn :href="`https://twitter.com/intent/tweet?url=${currentUrl}`" icon class="my-2" target="_blank" color="grey lighten-1">
                  <v-icon>mdi-twitter</v-icon>
              </v-btn>
              <br>
              <v-btn href="mailTo:info@agoffice.gov.mv" icon class="my-2" target="_blank" color="grey lighten-1">
                  <v-icon>mdi-email</v-icon>
              </v-btn>
          </div>
      </v-col>

    </v-row>

  </div>
</template>

<script>
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme

export default {
  props: ['navItems'],
  data: ()=>({
    news: {},
    currentUrl: window.location.href,
    loadingPage: true
  }),
  created() {
    // console.log(this.$route.params.contentType)
    if (this.$route.params.contentType === 'Organization Structure') {
      this.$http.get(`${this.$url}/pagination/2/Division Heads?limit=20&title.contains=${this.$route.params.title}&page=0&sort=id desc`).then((response)=>{
        this.news = response.data.data.rows
        this.loadingPage = false
      })
    } else if (this.$route.params.contentType === 'Meet our Colleagues' || this.$route.params.contentType === 'Meet our Interns') {
      this.$http.get(`${this.$url}/pagination/2/Join Us/${this.$route.params.contentType}?&Title.contains=${this.$route.params.title}&limit=10&page=0&sort=id%20desc`).then((response)=>{
        this.news = response.data.data.rows
        this.loadingPage = false
      })
    } else {
      this.$http.get(`${this.$url}/pagination/2/About Us/Senior Management?&title.contains=${this.$route.params.title}&limit=10&page=0&sort=id%20desc`).then((response)=>{
        this.news = response.data.data.rows
        this.loadingPage = false
      })
    }
    
  },
  methods: {
    getImage(item) {
      if (item.Files && item.Files.length > 0) {
          let images = item.Files.filter(obj => obj.FileType.includes('image'))
          if (images.length > 0) {
          return `${this.$url}/downloadfile/${images[0].ID}`
          }
          else {
          return ''
          }
      }
      else {
          return ''
      }
    },
    removeFirstPageQuote(text) {
      let splitSentence = text.split('First page quotation')
      if (splitSentence.length > 1) {
          return splitSentence[0]
      } else {
          return text
      }
    }
  }
}
</script>

<style lang="css">

[v-cloak] { display: none; }
.ql-editor p {
  line-height: 1.67 !important;
  padding-bottom: 10px;
  margin-bottom: 10px;
  
}
</style>